<template>
    <div class="flex relative border border-r-0 border-gray-400 w-full">
        <VueWindowResize v-model="window" v-show="false" />

        <div class="flex-1">
            <div class="flex flex-col sm:flex-row px-4 py-2 group bg-gray-warm-100 hover:bg-blue-100 cursor-pointer items-center justify-between focus:outline-none focus:shadow-none select-none border-b border-gray-400"
            >
                <div class="w-full sm:w-auto">
                    <div class="flex flex-col sm:flex-row items-baseline justify-center sm:justify-start font-semibold text-black group-hover:text-blue-700 leading-none mt-3 mb-2 sm:my-2"
                        :class="size == 'small' ? 'text-md' : 'text-lg'"
                    >
                        <span v-if="property.address">
                            {{ property.address }}{{ city }}{{ state }}
                        </span>

                        <span v-else>
                            Your property
                        </span>
                    </div>

                    <div class="block sm:hidden">
                        <dashboard-property-status
                            :status="property.status.overall"
                        />
                    </div>
                </div>

                <div class="hidden sm:block">
                    <dashboard-property-status
                        :status="property.status.overall"
                    />
                </div>
            </div>

            <div :class="size == 'small' ? 'flex flex-col sm:flex-row pl-10' : 'flex'" >
                <component :is="step_component"
                    label="Inspection Date"
                    :status="property.status.sections.inspection"
                    :first="true"
                    :order="1"
                    :id="property.id"
                    focus_field="inspection-date"
                    :route="section_route + '/inspection'"
                />

                <component :is="step_component"
                    label="Attorney Review Date"
                    :status="property.status.sections.attorney"
                    :order="2"
                    :id="property.id"
                    focus_field="attorney-review-date"
                    :route="section_route + '/attorney'"
                />

                <component :is="step_component"
                    v-if="! property.mortgage.is_cash_purchase"
                    label="Mortgage Contingency Date"
                    :status="property.status.sections.mortgage"
                    :order="3"
                    :id="property.id"
                    focus_field="mortgage-contingency-date"
                    :route="section_route + '/mortgage'"
                />

                <component :is="step_component"
                    label="Closing Date"
                    :status="property.status.sections.closing"
                    :order="4"
                    :id="property.id"
                    focus_field="scheduled-closing-date"
                    :route="section_route + '/closing'"
                />
            </div>
        </div>

        <div class="border-r-4" :class="status_class"></div>
    </div>
</template>

<script>
import DashboardPropertyStatus from './dashboard-property-status.vue';
import DashboardStep from './dashboard-step.vue';
import DashboardStepSmall from './dashboard-step-small.vue';
import VueWindowResize from 'vue-window-resize';

export default {
    components: {
        DashboardPropertyStatus,
        DashboardStep,
        DashboardStepSmall,
        VueWindowResize
    },

    props: {
        property: {},
        section_route: {},
    },

    data() {
        return {
            window: {
                width: 0,
                height: 0,
            },
        }
    },

    computed: {
        step_component() {
            return this.size == 'small' ? DashboardStepSmall : DashboardStep;
        },
        size() {
            return this.window.width > 1170 ? 'normal' : 'small';
        },
        city() {
            return this.property.city ? ', ' + this.property.city : '';
        },
        state() {
            return this.property.state ? ', ' + this.property.state : '';
        },
        status_class() {
            switch (this.property.status.overall) {
                case 'red':
                    return 'border-red-500';
                case 'yellow':
                    return 'border-yellow-500';
                default:
                    return 'border-green-500';
            }
        },
    },
}
</script>
